import { z } from 'zod';
import { locationSchema } from './ILocation';
import { roomSchema } from './IRoom';
import { legalTransactionTalkRoomDraftSchema } from './ILegalTransactionTalkRoom';
import { legalClientSchema } from './ILegalClient';

export const legalTransactionMeetingSchema = z.object({
  idLegalTransactionMeeting: z.number().default(-1),
  idLegalTransaction: z.number().default(-1),
  LegalTransactionMeeting: z.string().default(''),
  Meeting_at: z.string().default(''),
  DurationInMin: z.number().nullable().default(null),
  idLocation: z.number().nullable().default(null),
  idRoom: z.number().nullable().default(null),
  idLegalTransactionTalkRoom: z.number().nullable().default(null),
  // Kalender-Verknuepfung (Phase 4): Event-ID beim Provider + Verbindung.
  CalendarEventId: z.string().nullable().optional(),
  idUserCalendarConnection: z.number().nullable().optional(),
  // Transientes UI-Flag: steuert das Eintragen/Entfernen im Kalender beim Speichern.
  linkToCalendar: z.boolean().optional(),
  LocationObject: locationSchema.nullable().optional(),
  RoomObject: roomSchema.nullable().optional(),
  TalkRoomObject: legalTransactionTalkRoomDraftSchema.nullable().optional(),
  LegalClientArray: z.array(legalClientSchema).optional(),
});

export type ILegalTransactionMeeting = z.infer<
  typeof legalTransactionMeetingSchema
>;
